import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { EmptyForm, Filter, IEmptyForm } from "./Filter";
import { format, set } from "date-fns";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { baseUrl, Fetch, ILazyParams } from "../../shared/Fetch";
import { Note } from "./Note";
import { SendEmail } from "./SendEmail";
import { Sub_ECI } from "./Sub_ECI";
import { ViewPdf } from "./ViewPdf";
import { IVisaDropdown } from "../../models/IDropdown";
import { Dialog } from "primereact/dialog";
import { Search } from "../../shared/Search";
import { ILogin } from "../../models/Login";

interface IProps {
    toast: any
}

interface IStateWiseCount {
    state_ID?: number,
    state_Name?: string,
    conCount?: number,
}

interface IPrevWeekSubCount {
    conCount?: number,
    conCountWeek?: number[]
}

interface VisaNameCount {
    visaId?: number,
    name?: string,
    conCount?: number,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [tableData2, setTableData2] = useState({ tableData: tableData.tableData, loading: false } as { tableData: any[], loading: boolean });
    const [selectedConsultant, setSelectedConsultant] = useState<any[]>([]);
    const [sFilter, setSFilter] = useState<IEmptyForm>(EmptyForm);
    const [showFilter, setShowFilter] = useState<boolean>(true);
    const [showNote, setShowNote] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any });
    const [showSubECI, setShowSubECI] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any });
    const [showPDF, setShowPDF] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any });
    const [showSendEmail, setShowSendEmail] = useState<boolean>(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [prevWeekSubCount, setPrevWeekSubCount] = useState<IPrevWeekSubCount>({});
    const [prevWeekECICount, setPrevWeekECICount] = useState<IPrevWeekSubCount>({});
    const [visa, setVisa] = useState<Array<VisaNameCount>>([]);
    const [states, setStates] = useState<Array<IStateWiseCount>>([]);
    const [openModal, setOpenModal] = useState({ openVisa: false, openState: false } as { openVisa: boolean, openState: boolean });
    const [filterApply, setFilterApply] = useState(false);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 50,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }
    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const sendEmail = () => {
        if (selectedConsultant.length > 0) {
            setShowSendEmail(true);
        } else {
            props.toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one consultant to send email' });
        }
    }

    const rightToolbarTemplate = () => {
        return (
            <div className="flex gap-2">
                {selectedConsultant.length > 0 && <Button label="Send Email" onClick={sendEmail} />}
            </div>
        );
    };

    const rightToolbarTemplate2 = () => {
        //consultant_Name
        return (
            <>
                <Search setSearch={setGlobalFilter} />
            </>
        );
    }

    const leftToolbarTemplate = () => {
        return (
            <div className="flex gap-2">
                {!showFilter && <Button label="New Search" onClick={() => {
                    setShowFilter(true); setLazyParams({
                        first: 0,
                        rows: 50,
                        page: 1,
                        sortField: 'consultant_ID',
                        sortOrder: -1
                    }); setSFilter(EmptyForm); setTableData({ tableData: [], loading: false });
                }} />}
            </div>
        );
    }

    const loadTableData = async (query?: string, lazyParams2?: ILazyParams) => {
        let apiQuery: string = `lazyParams=${JSON.stringify(lazyParams2 || lazyParams)}&filter=${query}&consName=${globalFilter !== null ? globalFilter : ""}`;
        // if (query !== undefined && query !== null && query.trim() !== "") {
        //     apiQuery = `&queriesForSearch=${query}`;
        // };
        setLoading(true);

        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Mast/getSearchedConsultant", "GET", null, apiQuery, props.toast);
        if (response) {
            const data: any = await response.json();
            if (data.length > 0) {
                setShowFilter(false);
                if (data[0].total_Count !== undefined && data[0].total_Count !== null && data[0].total_Count > 0) {
                    setTotalRecords(data[0].total_Count);
                }
            } else props.toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'No Consultant Found' });
            setTableData({ tableData: data, loading: false });
            setTableData2({ tableData: data, loading: false });
            if (data[0]?.prevWeekSubCount !== undefined && data[0]?.prevWeekSubCount !== null) { setPrevWeekSubCount(data[0]?.prevWeekSubCount); };
            if (data[0]?.prevWeekECICount !== undefined && data[0]?.prevWeekECICount !== null) { setPrevWeekECICount(data[0]?.prevWeekECICount); };
            if (data[0]?.visasCount?.length > 0) { setVisa((data[0]?.visasCount || [{ visaId: 0, name: "", conCount: 0 }]).filter((el: any) => el.conCount !== 0)); };
            if (data[0]?.stateWiseCount?.length > 0) { setStates(data[0]?.stateWiseCount); };
            setOpenModal({ openVisa: false, openState: false });
            setLoading(false);
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
            setLoading(false);
        }
    }

    const consultantName = (data: any) => {
        return <p className="cursor-pointer underline text-cyan-700" onClick={() => setShowPDF({ open: true, singleData: data })}>{data.consultant_Name}</p>
    }
    const submital = (data: any) => {
        return <p className="cursor-pointer underline text-cyan-700" onClick={() => setShowSubECI({ open: true, singleData: data })}>{data.submittals}</p>
    }
    const note = (data: any) => {
        return <p className="cursor-pointer underline text-cyan-700" onClick={() => setShowNote({ open: true, singleData: data })}>Note</p>
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Searched Consultant</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                    {prevWeekSubCount && <Button label={"7 Days Sub Count - " + prevWeekSubCount.conCount} loading={loading} disabled={loading} className="p-button-info px-2 py-2 mx-1" tooltip={"Consultant Submitted In Last 7 Days"} tooltipOptions={{ position: 'top' }} onClick={() => {
                        setSFilter({ ...sFilter, searchForECI: false, searchForSub: true, all: false, searchForVisa: null, searchForState: null });
                        setLazyParams({
                            first: 0,
                            rows: 50,
                            page: 1,
                            sortField: 'consultant_ID',
                            sortOrder: -1
                        });
                        loadTableData(encodeURIComponent(JSON.stringify({ ...sFilter, searchForECI: false, searchForSub: true, all: false, searchForVisa: null, searchForState: null })));
                    }} />}
                    {prevWeekECICount && <Button label={"15 Days ECI Count - " + prevWeekECICount.conCount} loading={loading} disabled={loading} className="p-button-info px-2 py-2 mx-1" tooltip={"Consultant Submitted In Last 7 Days"} tooltipOptions={{ position: 'top' }} onClick={() => {
                        setSFilter({ ...sFilter, searchForSub: false, searchForECI: true, all: false, searchForVisa: null, searchForState: null });
                        setLazyParams({
                            first: 0,
                            rows: 50,
                            page: 1,
                            sortField: 'consultant_ID',
                            sortOrder: -1
                        });
                        loadTableData(encodeURIComponent(JSON.stringify({ ...sFilter, searchForSub: false, searchForECI: true, all: false, searchForVisa: null, searchForState: null })));
                    }} />}
                    {visa?.length > 0 && <Button label={`${visa.length} Visa Wise Count`} className="p-button-info px-2 py-2 mx-1" onClick={() => setOpenModal({ openVisa: true, openState: false })} />}
                    {states?.length > 0 && <Button label={`${states.length} State Wise Count`} className="p-button-info px-2 py-2 mx-1" onClick={() => setOpenModal({ openVisa: false, openState: true })} />}
                    <Button label={"All"} className="p-button-info px-2 py-2 mx-1" tooltip={"All"} loading={loading} disabled={loading} tooltipOptions={{ position: 'top' }} onClick={() => {
                        setSFilter({ ...sFilter, searchForSub: false, searchForVisa: null, searchForState: null, searchForECI: false, all: true });
                        setLazyParams({
                            first: 0,
                            rows: 50,
                            page: 1,
                            sortField: 'consultant_ID',
                            sortOrder: -1
                        });
                        loadTableData(encodeURIComponent(JSON.stringify({ ...sFilter, searchForVisa: null, searchForState: null, searchForSub: false, searchForECI: false, all: true })));
                    }} />
                </div>
            </span>
        </div>
    );

    useEffect(() => {
        if (!showFilter && tableData.tableData.length > 0 && lazyParams.first !== 0) {
            loadTableData(encodeURIComponent(JSON.stringify(sFilter)));
        }
    }, [lazyParams]);

    useEffect(() => {
        if (globalFilter !== null && globalFilter?.trim() !== "") {
            loadTableData(encodeURIComponent(JSON.stringify(sFilter)));
        }
    }, [globalFilter]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            {_roles.includes(1) && <Toolbar className="mb-1 py-0" right={rightToolbarTemplate2}></Toolbar>}
            {/* <Accordion>
                <AccordionTab header="Filter"> */}
            <Filter sFilter={sFilter} setSFilter={(sFilter: IEmptyForm) => setSFilter(sFilter)} loading={tableData.loading} loadTableData={loadTableData} showFilter={showFilter} lazyParams={lazyParams} filterApply={filterApply} />
            {/* </AccordionTab>
            </Accordion> */}
            {!showFilter && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="consultant_ID"

                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Consultant found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                selection={selectedConsultant}
                onSelectionChange={(e) => {
                    const value = e.value as any[];
                    setSelectedConsultant(value);
                }}
                selectionMode={'checkbox'}
            >
                <Column selectionMode="multiple" />
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_ID" header="Cons ID" />
                <Column field="consultant_Name" header="Consultant Name" body={(rowData) => consultantName(rowData)} />
                <Column field="consultant_Job_Title" header="Job Title" />
                <Column field="total_Experience" header="Exp." />
                <Column field="visa_Name" header="Visa" />
                <Column field="current_Location" header="Current Location" />
                <Column field="submittals" header="Submittals/ECI" body={(rowData) => submital(rowData)} />
                <Column field="relocation" header="Relocation" />
                <Column field="availabilityDays" header="Availability" />
                <Column header="Note" body={(rowData) => note(rowData)} />

                {/* <Column field="consultant_Added_ByUser" header="Added By" />
                <Column field="consultant_Home_No" header="Home No" />
                <Column field="consultant_Cell_No" header="Cell No" />
                <Column field="city_Name" header="City" />
                <Column field="submittals" header="Submittals" />
                <Column field="state_Name" header="State" />
                <Column field="state_Name1" header="State" />
                <Column field="consultant_Email_ID" header="Email" /> */}
            </DataTable>}
            <Sub_ECI open={showSubECI.open} singleData={showSubECI.singleData} onClose={() => setShowSubECI({ open: false, singleData: {} })} toast={props.toast} />
            <Note open={showNote.open} singleData={showNote.singleData} onClose={() => setShowNote({ open: false, singleData: {} })} toast={props.toast} />
            <SendEmail
                open={showSendEmail}
                tableData={selectedConsultant}
                onClose={() => {
                    setShowSendEmail(false);
                    setSelectedConsultant([]);
                }}
                toast={props.toast}
            />
            <ViewPdf open={showPDF.open} singleData={showPDF.singleData} searchQuery={sFilter.query || ""} onClose={() => setShowPDF({ open: false, singleData: {} })} toast={props.toast} />
            <Dialog visible={openModal.openVisa} style={{ width: '80vw' }} header="Visa Wise Consultant Count" modal className="p-fluid" onHide={() => setOpenModal({ openVisa: false, openState: false })}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: "2rem", width: "100%" }}>
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px", width: "100%" }}
                        ref={dt} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                        value={visa} lazy dataKey="visaId"
                        emptyMessage="No Date found."
                    >
                        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                        <Column field="name" header="Visa" />
                        <Column field="conCount" header="Count" />
                        <Column field="visaId" header="View" body={(rowData) => <Button label="View" loading={loading} disabled={loading} className="p-button-info px-2 py-2 mx-1" style={{ width: "5rem" }} onClick={(row: any) => {
                            setSFilter({ ...sFilter, searchForSub: false, searchForECI: false, searchForState: null, searchForVisa: rowData.visaId, all: false });
                            loadTableData(encodeURIComponent(JSON.stringify({ ...sFilter, searchForSub: false, searchForECI: false, searchForState: null, searchForVisa: rowData.visaId, all: false })), {
                                first: 0,
                                rows: 50,
                                page: 1,
                                sortField: 'consultant_ID',
                                sortOrder: -1
                            });
                            setLazyParams({
                                first: 0,
                                rows: 50,
                                page: 1,
                                sortField: 'consultant_ID',
                                sortOrder: -1
                            });
                        }} />} />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog visible={openModal.openState} style={{ width: '80vw' }} header="State Wise Consultant Count" modal className="p-fluid" onHide={() => setOpenModal({ openVisa: false, openState: false })}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: "2rem", width: "100%" }}>
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px", width: "100%" }}
                        ref={dt} size="large" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                        value={states} lazy dataKey="state_ID"
                        emptyMessage="No Date found."
                    >
                        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                        <Column field="state_Name" header="State" />
                        <Column field="conCount" header="Count" />
                        <Column field="state_ID" header="View" body={(rowData) => <Button label="View" loading={loading} disabled={loading} className="p-button-info px-2 py-2 mx-1" style={{ width: "5rem" }} onClick={(row: any) => {
                            setSFilter({ ...sFilter, searchForSub: false, searchForECI: false, searchForVisa: null, searchForState: rowData.state_Name, all: false });
                            setLazyParams({
                                first: 0,
                                rows: 50,
                                page: 1,
                                sortField: 'consultant_ID',
                                sortOrder: -1
                            });
                            loadTableData(encodeURIComponent(JSON.stringify({ ...sFilter, searchForSub: false, searchForECI: false, searchForVisa: null, searchForState: rowData.state_Name, all: false })), {
                                first: 0,
                                rows: 50,
                                page: 1,
                                sortField: 'consultant_ID',
                                sortOrder: -1
                            });
                        }} />} />
                    </DataTable>
                </div>
            </Dialog>
        </>
    );
}